import { Organisation } from "../organisation/Organisation"

export class BigOpportunityModel {
    current_price?: number
    extraction_rate?: number
    org?: Organisation
    tenera_ratio?: number
    tonnage?: number
    contact_position?: any
    rejection_reason?: string

    constructor(d: any) {
        this.current_price = d.current_price
        this.extraction_rate = d.extraction_rate
        this.org = d.organisation_id ?
            Organisation.build({ id: d.organisation_id, name: d.organisation_name, positionepsg4326: d.organisation_position })
            : undefined
        this.tenera_ratio = d.tenera_ratio
        this.tonnage = d.tonnage
        this.contact_position = d.contact_position
        this.rejection_reason = d.rejection_reason
    }

    static build(d: any): BigOpportunityModel {
        return new BigOpportunityModel(d)
    }
}